import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "../../../styles/automation/wati-keyoword-logs.css";
import AddKeyword from "./AddKeyword";
import { selectAuth } from "../../auth/auth.selector";
import LeadLogs from "../tables/LeadLogs";
import {
  fetchAllKeywordsData,
  fetchAllWatiLogsData,
  fetchSheetTabsStatsData,
} from "../../../redux/reducers/apiSlice";
import AllKeywords from "../tables/AllKeywords";
import KeywordFilterStructures from "./KeywordFilterStructures";
import HelmetWrapper from "../../../HelmetWrapper";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import LeadKeywords from "../automation-lead-keywords/LeadKeywords";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AddKeywordsForm from "./AddKeywordsForm";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { deleteKeyword } from "../../../redux/reducers/deleteApiSlice";
import { fetchGymKeywordsData } from "../../../redux/prospect-reducers/prospectSlice";
import GymAliasStructure from "../../gym-alias/GymAliasStructure";
// import CommonStructured from "../../common-components/CommonStructured";

const KeywordActions = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { allKeywords, watiLogs, sheetAndTabs } = useSelector(
    (state) => state.api
  );

  const initialKeywordsData = {
    allKeywords: [],
    pagination: [],
    isPage: 0,
  };
  const [allKeyData, setAllKeyData] = useState(initialKeywordsData);
  const initialFilters = {
    sheet_id: "",
    tab_name: "",
    searchString: "",
    isPage: 0,
  };
  const [filterValues, setFilterValues] = useState(initialFilters);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const initialTableDatas = {
    allLogsData: [],
    allTabsData: [],
    pagination: [],
    isPage: 0,
  };
  const [allLogs, setAllLogs] = useState(initialTableDatas);
  const [sheetNTabsData, setSheetNTabsData] = useState([]);
  const [sendableQP, setSendableQP] = useState("");
  const [sendableKeyQP, setSendableKeyQP] = useState("");
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const initialFormInputs = {
    predefinedMsg: "",
    tabName: "",
    sheetName: "",
    sheetId: "",
    status: "",
    uid: "",
    isAddToLead: false,
  };
  const [formValues, setFormValues] = useState(initialFormInputs);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function closeModal() {
    setModValues(iniModvalues);
  }

  const onClickEdit = (e, rowData) => {
    e.preventDefault();

    setFormValues({
      predefinedMsg: rowData?.predefined_msg || "",
      tabName: rowData?.tab_name || "",
      sheetName: rowData?.sheet_name || "",
      sheetId: rowData?.sheet_id || "",
      status: rowData?.status
        ? { label: rowData.status, value: rowData.status }
        : "",
      uid: rowData?.uid || "",
      isAddToLead:
        rowData?.lead_capture === "true" && rowData?.lead_capture !== "null"
          ? true
          : false,
    });

    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: "edit",
    }));
  };

  const onClickSearch = () => {
    const searchQP = filterValues.searchString
      ? `&search=${filterValues.searchString}`
      : "";

    setSendableQP((prevQP) => prevQP + searchQP);
  };

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setAllKeyData((prevs) => ({
      ...prevs,
      isPage: 0,
    }));
  }

  const onClickSearchKeyword = () => {
    if (allFilters.searchString) {
      const searchQP = `&search=${allFilters.searchString}`;

      setSendableKeyQP((prevQP) => {
        const cleanedQP = prevQP.replace(/&search=[^&]*/, "");
        return cleanedQP + searchQP;
      });

      setAllKeyData((prevs) => ({
        ...prevs,
        isPage: 0,
      }));
      setSearchFilterApplied(true);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const handleDeleteKeyword = async (e, uid) => {
    e.preventDefault();

    if (uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            deleteKeyword({
              TOKEN: decryptedText?.token,
              filters: { uid: uid },
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Predefined message is deleted successfully!"
            );
            getCombineReload();
          } else {
            toast.error(
              response?.message || "Can not delete Predefined Message!"
            );
          }
        } catch (error) {
          toast.error(error || "Failed to delete keyword");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this keyword!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  function getAllKeywords() {
    dispatch(
      fetchAllKeywordsData({
        pageNo: allKeyData.isPage + 1,
        queryParameters: sendableKeyQP + "&auto_gym_map=0",
        token: decryptedText?.token,
      })
    );
  }

  function getWatiLogs() {
    dispatch(
      fetchAllWatiLogsData({
        pageNo: allLogs.isPage + 1,
        queryParameters: sendableQP,
        token: decryptedText?.token,
      })
    );
  }

  function getGymKeywords(filters) {
    dispatch(
      fetchGymKeywordsData({
        filters: {
          ...filters,
          page: filters?.page || 1,
          limit: filters?.limit || 10,
        },
        token: decryptedText?.token,
      })
    );
  }

  function getCombineReload() {
    getWatiLogs();
    getAllKeywords();
    getGymKeywords({ page: allLogs.isPage + 1, limit: 10 });
  }

  useEffect(() => {
    const sheetIdQP = filterValues.sheet_id
      ? `&sheet_id=${filterValues.sheet_id}`
      : "";
    const tabNameQP = filterValues.tab_name
      ? `&tab_name=${filterValues.tab_name}`
      : "";
    const allQPs = `${sheetIdQP}${tabNameQP}`;
    setSendableQP(allQPs);
  }, [filterValues]);

  useEffect(() => {
    if (filterValues.searchString?.length === 0) {
      setSendableQP((prevQP) => prevQP.replace(/&search=[^&]*/, ""));
    }
  }, [filterValues.searchString]);

  useEffect(() => {
    getAllKeywords();
    // dispatch(
    //   fetchAllKeywordsData({
    //     pageNo: allKeyData.isPage + 1,
    //     queryParameters: sendableKeyQP,
    //     token: decryptedText?.token,
    //   })
    // );
  }, [sendableKeyQP, allKeyData.isPage]);

  useEffect(() => {
    getWatiLogs();
    // dispatch(
    //   fetchAllWatiLogsData({
    //     pageNo: allLogs.isPage + 1,
    //     queryParameters: sendableQP,
    //     token: decryptedText?.token,
    //   })
    // );
  }, [sendableQP, allLogs.isPage]);

  useEffect(() => {
    dispatch(
      fetchSheetTabsStatsData({
        token: decryptedText?.token,
      })
    );
  }, []);

  useEffect(() => {
    if (watiLogs?.status && watiLogs?.data?.length > 0) {
      const allSheetIds = watiLogs.data.map((sheet) => sheet?.tab_name);
      setAllLogs((prevs) => ({
        ...prevs,
        allLogsData: watiLogs.data,
        pagination: watiLogs?.pagination,
        allTabsData: allSheetIds,
      }));
    } else {
      setAllLogs(initialTableDatas);
    }

    if (allKeywords?.status && allKeywords?.data?.length > 0) {
      setAllKeyData((prevs) => ({
        ...prevs,
        allKeywords: allKeywords.data,
        pagination: allKeywords?.pagination,
      }));
    } else {
      setAllKeyData(initialKeywordsData);
    }

    if (sheetAndTabs?.status && sheetAndTabs?.data?.length > 0) {
      setSheetNTabsData(sheetAndTabs.data);
    }
  }, [watiLogs, allKeywords, sheetAndTabs]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSendableKeyQP((prevQP) => prevQP.replace(/&search=[^&]*/, ""));
      setSearchFilterApplied(false);
      setAllKeyData((prevs) => ({
        ...prevs,
        isPage: 0,
      }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Wati Keywords">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Wati Keywords Modal"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            <ModalHeadAndClose
              title={`${
                modValues.modName === "edit"
                  ? "Edit Wati Keywords"
                  : modValues.modName === "add"
                  ? "Add Wati Keywords"
                  : modValues.modName === "copy"
                  ? "Copy Wati Keywords"
                  : modValues.modName === "description" ||
                    modValues.modName === "sheet_id"
                  ? modValues.rowData?.sheet_name || " "
                  : modValues.modName?.replace(/_/g, " ")
              }`}
              onClose={closeModal}
            />

            {modValues.modName === "edit" ||
            modValues.modName === "copy" ||
            modValues.modName === "add" ? (
              <AddKeywordsForm
                decryptedText={decryptedText}
                isEdit={modValues.modName === "edit"}
                isCopy={modValues.modName === "copy"}
                callKeyFunction={getCombineReload}
                onCloseModal={closeModal}
                editIniFormvalues={formValues}
              />
            ) : modValues.modName === "description" ||
              modValues.modName === "sheet_id" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.modName === "description"
                    ? modValues.rowData?.predefined_msg
                    : modValues.rowData?.sheet_id || "No Content Available"}
                </p>
              </div>
            ) : null}
          </div>
        </Modal>

        {/* <Row>
          <Col>
            <AddKeyword
              decryptedText={decryptedText}
              callKeyFunction={() => {
                getAllKeywords();
                getGymKeywords({ page: allLogs.isPage + 1, limit: 10 });
              }}
            />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <div
              // className="odm-tabs-new"
              className="discount-payments-tabs bgTransParent odm-wati-container"
            >
              <Tabs
              // onSelect={handleTabSelect}
              >
                <TabList>
                  <Tab>Non-mapped Keywords</Tab>
                  <Tab>gym Mapped Keywords</Tab>
                  <Tab>All Lead Logs</Tab>
                  <Tab>Gym Alias</Tab>
                </TabList>

                <TabPanel>
                  <br />
                  <AddKeyword
                    decryptedText={decryptedText}
                    callKeyFunction={() => {
                      getAllKeywords();
                      getGymKeywords({ page: allLogs.isPage + 1, limit: 10 });
                    }}
                  />

                  <CommonFilterStructure
                    from="automation-keywords"
                    // from="only-search"
                    decryptedText={decryptedText}
                    onClickReset={onResetFilters}
                    filters={allFilters}
                    setFilters={setAllFilters}
                    onClickSearch={onClickSearchKeyword}
                    searchFilterApplied={searchFilterApplied}
                  />
                  <br />

                  <AllKeywords
                    allKeyData={allKeyData}
                    setAllKeyData={setAllKeyData}
                    setModValues={setModValues}
                    onClickEdit={onClickEdit}
                    handleDeleteKeyword={handleDeleteKeyword}
                  />
                </TabPanel>

                <TabPanel>
                  <AddKeyword
                    decryptedText={decryptedText}
                    callKeyFunction={() => {
                      getAllKeywords();
                      getGymKeywords({ page: allLogs.isPage + 1, limit: 10 });
                    }}
                  />

                  <LeadKeywords
                    userInfoData={decryptedText}
                    setModValues={setModValues}
                    onClickEdit={onClickEdit}
                    handleDeleteKeyword={handleDeleteKeyword}
                  />
                </TabPanel>

                <TabPanel>
                  <KeywordFilterStructures
                    decryptedText={decryptedText}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    onClickSearch={onClickSearch}
                    handleKeyPress={handleKeyPress}
                  />

                  <LeadLogs
                    setFilterValues={setFilterValues}
                    allLogs={allLogs}
                    setAllLogs={setAllLogs}
                    sheetNTabsData={sheetNTabsData}
                  />
                </TabPanel>

                <TabPanel>
                  <GymAliasStructure userInfoData={decryptedText} />
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>

        {/* <Row>
          <Col>
            <CommonStructured
              pageHeading={"All Lead Logs"}
              isReload={getWatiLogs}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <KeywordFilterStructures
              decryptedText={decryptedText}
              filterValues={filterValues}
              setFilterValues={setFilterValues}
              onClickSearch={onClickSearch}
              handleKeyPress={handleKeyPress}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <LeadLogs
              setFilterValues={setFilterValues}
              allLogs={allLogs}
              setAllLogs={setAllLogs}
              sheetNTabsData={sheetNTabsData}
            />
          </Col>
        </Row> */}
      </Container>
    </HelmetWrapper>
  );
};

export default KeywordActions;
